module.exports = __webpack_public_path__ + "static/media/Software-Developer.e36dccf6.png";